import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import "react-table/react-table.css";
import couterpart from 'counterpart';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';

class LayerOne extends Component {
  constructor () {
    super();
    this.state = {
      count: 0
    };
  }

  componentDidMount () {
    WorkOrderDataService.countByDeadline({}).then(data => {
      this.setState({ 
          count:  data
      });
    });
  }

  viewDetails() {
    if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
      WorkOrderUtil.removeItem('prod.fromDate')
      WorkOrderUtil.removeItem('prod.fromDate') 
      WorkOrderUtil.saveItem('prod.deadline', 1)     
      this.props.history.push("/products?status=" + this.state.status);
      return;
    }

    if (AuthenticationService.isShipping()){
      WorkOrderUtil.removeItem('shipOrders.fromDate')
      WorkOrderUtil.removeItem('shipOrders.fromDate')
      WorkOrderUtil.saveItem('shipOrders.deadline', 1)
      this.props.history.push("/shipOrders?status=" + this.state.status);
      return;
    }
  }

  render() {
    return (
      <Card className="label_link" style={{ width: '18rem' }} onClick={ this.viewDetails.bind(this) }>
        <Card.Body>
          <Card.Title> <label style={{ color: 'black' }}>{ 'Phân công thợ' } </label></Card.Title>
          <Card.Text>
            {/* { this.state.count } */}
          </Card.Text>
          {/* <Button className="myButton" onClick={this.viewDetails.bind(this)}>{ couterpart.translate('wo_goto_details') }</Button> */}
        </Card.Body>
      </Card>  
    )
  }
}

export default withRouter(LayerOne);